import moment from 'moment'

const cashePrefix = 'eam_cache_'

export async function getOrSetCachedValue(key, timeout, getFunc) {
  const fullKey = cashePrefix + key
  try {
    const valueStr = localStorage.getItem(fullKey)
    if (valueStr) {
      const valueObj = JSON.parse(valueStr)
      if (valueObj.timestamp && valueObj.item && moment().add(-timeout, 'second') < moment(valueObj.timestamp)) {
        return valueObj.item
      }
    }
  } catch (error) {
    console.log(error)
  }
  const item = await getFunc()
  try {
    const valueToSave = JSON.stringify({
      item,
      timestamp: moment().toISOString(),
    })
    localStorage.setItem(fullKey, valueToSave)
  } catch (error) {
    console.log(error)
  }

  return item
}

export async function clearCachedValues() {
  try {
    localStorage.removeItem('lastUpdated')

    Object.keys(localStorage)
      .filter((k) => k.startsWith(cashePrefix))
      .forEach((k) => {
        localStorage.removeItem(k)
      })
  } catch (error) {
    console.log(error)
  }
}
